<template>
	<section id="apropos" class="item">
<!--		<bread title="A propos de nous ..." desc="Découvrez pourquoi nous vous proposons d'utiliser CoproPrivée !"></bread>-->
		<div class="container">
			<div class="row">
				<div class="col-12 col-md-6">
					<h2>Mission</h2>
					<!--				<h2>Nos valeurs</h2>-->
					<!--						<p class="mb-3">-->
					<!--							En tant que copropriétaire, nous avons connu des syndics dont la transparence ou l’efficacité laisse à désirer...-->
					<!--						</p>-->
					<p class="mb-3">
						<!--							Face à ces difficultés, -->
						Nous vous permettons
						<!--							aujourd'hui-->
						de gérer vous-même votre copropriété,
						sans passer par un syndic professionnel.
					</p>

					<p class="mb-3">
						Petite copropriété ou ensemble immobilier plus important, l'application est faite pour vous aider à structurer votre organisation et simplifier la gestion de votre copropriété.
					</p>
					<!--							peu joignables;-->
					<!--							gestion opaque des comptes;-->
					<!--							temps de traitement trop longs;-->
					<!--							impayés impactant la comptabilité;-->
					<!--							mauvais entretient de l'immeuble;-->
					<!--							absence de négociation des contrats;-->
					<!--							engagement de factures abusives, inutiles ou coûteuses;-->
					<!--							honoraires exorbitants et des vacations facturées en supplément !-->
					<p class="mb-3">
						20% des copropriétés se passent aujourd’hui de syndics professionnels !
						<!--							L'envie de satisfaire les résidents dont vous faites partie vous tente ?-->
						Vous aussi, rejoignez le mouvement !
					</p>
					<p class="mb-3 mb-sm-0">
						<!--								En supprimant cet intermédiaire, il est possible d'économiser jusqu’à 50% des charges.-->
						<!--								&lt;!&ndash;								Les problématiques sont réglées immédiatement.&ndash;&gt;-->
						Impliquer ses voisins favorise d'ailleurs calme et convivialité.
						Tout&nbsp;le&nbsp;monde y trouve son compte !
						<!--								&lt;!&ndash;								Tout le monde y trouve son compte en trouvant, en toute transparence, toutes les informations.&ndash;&gt;-->
						<!--								&lt;!&ndash;								De quoi retrouver une convivialiré entre voisins.&ndash;&gt;-->
					</p>
				</div>
				<div class="col-12 col-md-6 footer-address">
					<h2 class="d-none d-sm-block">Réseaux</h2>
					<p>
						N'hésitez pas à nous contacter.<br>
						Nous serons ravis de faire votre conaissance !
					</p>
					<div class="btns">
						<!--								<li>-->
						<!--									<a class="link">-->
						<!--										<i class="fa fa-map"></i>-->
						<!--										<span>90 bis avenue Victor Cresson,<br>92130 Issy les Moulineaux</span>-->
						<!--									</a>-->
						<!--								</li>-->
						<!--								<li>-->
						<!--									<a class="link">-->
						<!--										<i class="fa fa-map"></i>-->
						<!--										<span>RCS XXXXXXXX Nanterre</span>-->
						<!--									</a>-->
						<!--								</li>-->
						<a class="btn btn-light" href="https://app.coproprivee.fr" @click="gtag('click', 'sign_in','apropos')" target="_blank" rel="noopener">
							<i class="fa fa-mobile-alt"></i>
							<span>L'application web CoproPrivée</span>
						</a>
						<br>
						<a class="btn btn-light" href="tel:+33652518721" @click="gtag('click', 'tel','apropos')" target="_blank" rel="nofollow noreferrer noopener">
							<i class="fa fa-phone"></i>
							<span>06&nbsp;52&nbsp;51&nbsp;87&nbsp;21</span>
						</a>
						<a class="btn btn-light" href="mailto:maxime@coproprivee.fr" @click="gtag('click', 'mail','apropos')" target="_blank" rel="nofollow noreferrer noopener">
							<i class="fa fa-envelope"></i>
							<span>maxime@coproprivee.fr</span>
						</a>
						<br>
						<a class="btn btn-light" :href="env.VUE_APP_SOCIAL_FB" @click="gtag('click', 'facebook','apropos')" target="_blank" rel="nofollow noreferrer noopener">
							<i class="fab fa-facebook-f"></i>
							<span>CoproPrivée</span>
						</a>
						<a class="btn btn-light" :href="env.VUE_APP_SOCIAL_TW" @click="gtag('click', 'twitter','apropos')" target="_blank" rel="nofollow noreferrer noopener">
							<i class="fab fa-twitter"></i>
							<span>CoproPrivée</span>
						</a>
					</div>

          <p class="mt-4">
            Nous remercions également toutes celles et ceux qui
            <router-link :to="{name:'soutien'}">nous soutiennent financièrement</router-link>.
<!--            qui permettent de faire perdurer le système.-->
          </p>

        </div>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
</style>
<script>
	export default{
		metaInfo() {
			if(!this.meta) return {};

			return {
				title: 'A propos de CoproPrivée',
				meta: [
					{name: 'description', content: 'Notre mission : Vous aider à structurer votre organisation et simplifier la gestion de votre copropriété.', id: 'desc'},
				]
			}
		},
		props:{
			meta: {default: true}
		},
	}
</script>
